import { SidebarFilter } from "@frameworks/web/components/generic/FilterSidbar/SidebarFilter";
import React from "react";
const FilterData = (props) => {
    const handleApply = (filterState) => {
        props.updateFilterState([...filterState]);
        props.setOpenDrawer(false);
    };
    return (React.createElement(SidebarFilter, { links: props.filterState, handleTitle: props.handleTitle, externalClassName: "common-filter-section common-filter-height", defaultActiveKey: props.activeKey, setActiveKey: props.setActiveKey, handleApply: handleApply, applyBtn: true, customDateFilter: props.customDateFilter, setCustomDateFilter: props.setCustomDateFilter, cancelAndApply: props.cancelAndApply, setOpenDrawer: props.setOpenDrawer, customCheckBoxFunction: props.customCheckBoxFunction }));
};
export default FilterData;
